export default __webpack_public_path__ + "static/media/picture-low.256d0e1e.jpg";